import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 120px;
  margin-bottom: 120px;
  padding-left: ${({ theme }) =>
    theme.layout.content.paddingHorizontal.desktop}px;
  padding-right: ${({ theme }) =>
    theme.layout.content.paddingHorizontal.desktop}px;

  @media only screen and (max-width: 1080px) {
    flex-wrap: wrap;
  }

  @media only screen and (max-width: 980px) {
    margin-top: 80px;
    margin-bottom: 80px;
    padding-left: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.ipad}px;
    padding-right: ${({ theme }) =>
      theme.layout.content.paddingHorizontal.ipad}px;
  }

  @media only screen and (max-width: 980px) {
    padding-left: 5px;
    padding-right: 5px;
  }
`;
